import { useMutation } from '@tanstack/react-query';

import { startTbcSession } from '../api/payment.api';

interface StartTbcSessionParams {
    orderId: string;
    loyaltyId: number;
}

export const useStartTbcSession = () => {
    return useMutation({
        mutationFn: ({ orderId, loyaltyId }: StartTbcSessionParams) =>
            startTbcSession(orderId, loyaltyId),
    });
};
